import axios from 'axios';
import { buildUrl } from './common';

export default axios.create({
  baseURL: buildUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});
